import { FC } from "react";
import { useLocationContext } from "../hooks/useLocationContext";
import { haversineDistance } from "../utils/calculateDistance";
import { ILocation } from "../types/ILocation";
import getColorFromDistance from "../utils/getColorFromDistance";
import { useTranslation } from 'react-i18next';

interface Props {
  tileLocation: ILocation;
}

const DistanceIndicator: FC<Props> = ({ tileLocation }) => {
  const { t } = useTranslation();
  const tBase = "views.calendar.components.DistanceIndicator";
  const tr = (key: string) => t(`${tBase}.${key}`);

  const { location } = useLocationContext();

  if (!location) return null;

  const distanceMeters = haversineDistance(location, tileLocation);
  const distanceMiles = distanceMeters / 1609.344;

  if (distanceMiles === null || distanceMiles === undefined) return null;

  const color = getColorFromDistance(distanceMiles);

  return (
    <div
      style={{ backgroundColor: color }}
      className="w-7 h-4 mr-[1px] mb-[1px] rounded-full absolute bottom-0 right-0 z-[2] shadow-md border border-gray-400"
      title={`${tr("Distance from selected")}: ${distanceMiles.toFixed(3)} miles`}
    >
      <div
        style={{
          fontSize: 10,
          textAlign: "center",
          justifyContent: "center",
          alignItems: "center",
          alignContent: "center",
          marginTop: -1,
          color: "white",
          textShadow: "1px 1px 2px black",
        }}
        className="text-center"
      >{`${distanceMiles.toFixed(1)}`}</div>
    </div>
  );
};

export { DistanceIndicator };
